module.exports = __webpack_public_path__ + "img/jumpilla-3.948b4908.jpg";